import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/contexts/LanguageContext';

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  type?: 'website' | 'article';
  noindex?: boolean;
}

const SITE_URL = 'https://tomartmask.cz';
const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

const defaults = {
  cs: {
    title: 'Tom Art Mask | Custom Airbrush Hokejové Masky na Zakázku',
    description:
      'Profesionální airbrush design hokejových masek na zakázku. Originální umělecké návrhy pro brankáře všech úrovní. 19+ let zkušeností. Třebíč, Česká republika.',
  },
  en: {
    title: 'Tom Art Mask | Custom Airbrush Hockey Goalie Masks',
    description:
      'Professional custom airbrush hockey mask design. Original artistic designs for goalies of all levels. 19+ years of experience. Třebíč, Czech Republic. Shipping across Europe.',
  },
};

const SEO = ({ title, description, path = '/', image, type = 'website', noindex = false }: SEOProps) => {
  const { lang } = useLanguage();
  const d = defaults[lang];
  const finalTitle = title ?? d.title;
  const finalDesc = description ?? d.description;
  const finalImage = image ?? DEFAULT_OG;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Canonical + hreflang */}
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="cs" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={lang === 'cs' ? 'cs_CZ' : 'en_US'} />
      <meta property="og:site_name" content="Tom Art Mask" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />
    </Helmet>
  );
};

export default SEO;
